<template>
  <div class="container">
    <img class="header" :src="require('@/assets/img/casesHead.jpg')" />
    <div class="form">
      <van-cell-group inset class="form-content" v-for="(item ,index) in envData" :key="item">
        <van-cell class="text flex">
          <div class="content">
          <div class="red">编号{{ index + 1 }}</div>
          </div>
          <a
            :href="`https://zsrbactivity.zsnews.cn/vue/epidemicMap/#/?latitude=${item.latitude}&longitude=${item.longitude}`"
          >
            <div class="form-button">查看地图</div>
          </a >
        </van-cell>
        <van-cell class="text">
        <div class="content">
          <div class="yellow">镇街</div>
          <div>{{ item.town }}</div>
          </div>
          </van-cell
        >
        <van-cell class="text">
           <div class="content">
          <div class="red">地址</div>
          <div>{{ item.address }}</div>
          </div>
          </van-cell>
        <van-cell class="text" >
          <div class="content">
          <div class="yellow">时间段</div>
          <div>{{ item.duration }}</div>
          </div>
        </van-cell>
      </van-cell-group>
      <van-button
        class="btn"
        round
        block
        type="default"
        icon-position="right"
        color="linear-gradient(to right,#699afa, #76c4f4)"
        url="https://zsrbactivity.zsnews.cn/vue/epidemic/"
        >返回</van-button
      >
    </div>
  </div>
</template>

<script>
import { Button, Cell, CellGroup } from "vant"
import { computed, onMounted, onBeforeUpdate } from "vue"
import { useStore } from "vuex"
import { wxshareInit } from "@/plugins/wechatSDK.js"
import "@/plugins/bridge.js"
// import { useRouter } from "vue-router"
export default {
  name: "Home",
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button
  },
  setup() {
    const store = useStore()
    // const router = useRouter()

    onMounted(() => {
      store.dispatch("getAppEnv")
    })

    onBeforeUpdate(() => {})

    return {
      envData: computed(() => store.state.envData)
    }
  },
  created() {
    window.ZsrbApp.call("shareInfo", {
      title: "中山疫情防控服务平台",
      img: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.png"),
      desc: "疫情防控一点通",
      url: "https://zsrbactivity.zsnews.cn/vue/epidemic/"
    })
    wxshareInit({
      title: "中山疫情防控服务平台",
      imgUrl: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.png"),
      description: "疫情防控一点通",
      url: "https://zsrbactivity.zsnews.cn/vue/epidemic/",
      successMethod: ""
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: #8acdf7;
  min-height: 100vh;
}
.swiper-carousel {
  // padding-bottom: 10px;
  .lazy_img {
    width: 100%;
    height: auto;
  }
}
.header {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
}
.form {
  position: relative;
  margin-top: 80vw;
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 30px;
}
.form-content {
  background: #ffff;
  padding: 20px 2px;
  // border-radius: 10px;
  --van-cell-group-inset-padding:0px;
  box-shadow: 1px 5px 5px -2px rgba($color: #777777, $alpha: 0.4);
  margin-bottom: 15px;
  .text {
    font-weight: 600;
    font-size: 3.6vw;
  }
  .content{
   display: flex;
   align-items: baseline;

  }
  .red {
     flex-shrink:0;
    background: #f87670;
    color: #ffffff;
    padding: 1px 5px;;
    margin-right: 6px;
    text-align: center;
    border-radius: 3px;
  }
  .yellow {
    flex-shrink:0;
    background: #ffc732;
    color: #ffffff;
    padding: 1px 5px;
    margin-right: 6px;
    text-align: center;
    border-radius: 3px;
  }
}

.form-button {
  background: linear-gradient(to bottom, #699afa, #76c4f4);
  height: 24px;
  line-height: 24px;
  padding: 0px 6px;
  border-radius: 6px;
  color: #ffffff;
  position: absolute;
  top: 0;
  right: 0;
}
.form-text {
  font-size: 3.8vw;
  color: #444;
}
.btn {
  margin-bottom: 30px;
}
</style>
